import {createStore} from 'vuex'
import HuntStore from './modules'
import CarStore from './modules/Car.store'
import RepairStore from './modules/Repair.store'

const modules = {
  Car: CarStore,
  RepairStore: RepairStore,
  Hunt: HuntStore,
}

export const store = createStore({
  modules,
})
